<div class="main-box no-border" *transloco="let t; prefix: 'fuelDashboard'">
  <div class="inner-body">
    <div class="card grap-card increase no-border">
      <div class="card-body p-0">
        <div class="grap-up d-flex align-items-center justify-content-between">
          <div class="graph-text">
            <h4>{{ t('widgets.totalDecrease') }}</h4>
            <p>
              {{ headline.value }} <strong>{{ headline.change }}</strong>
              <i><img src="./assets/images-fuel/upgreen-icon.svg" alt="down-icon" /></i>
            </p>
          </div>

          <div class="tab-button">
            <ul>
              <li>
                <button [class.active]="viewMode === 'all'" (click)="viewMode = 'all'">
                  {{ t('viewModes.all') }}
                </button>
              </li>
              <li>
                <button [class.active]="viewMode === 'unusual'" (click)="viewMode = 'unusual'">
                  {{ t('viewModes.unusualDecrease') }}
                </button>
              </li>
              <li>
                <button [class.active]="viewMode === 'driving'" (click)="viewMode = 'driving'">
                  {{ t('viewModes.drivingConsumption') }}
                </button>
              </li>
              <li>
                <button [class.active]="viewMode === 'idling'" (click)="viewMode = 'idling'">
                  {{ t('viewModes.idlingConsumption') }}
                </button>
              </li>
            </ul>
          </div>

          <div class="allbutton-wrapper">
            <div class="common-filter common-dropdown-checkbox">
              <div class="common-drop-down dropdown dropdown-icon-right">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-menu-button"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  {{ t('filters.filterByMakeAndModel') }}
                  <img src="assets/images-fuel/filterDrpDwnIcon.svg" alt="">
                </button>

                <ul class="dropdown-menu large-menu dropdown-menu-end checkbox-wrapper"
                  aria-labelledby="dropdown-menu-button" (click)="buttonMenuClick($event)">
                  <li>
                    <div class="dropdown-search drop-down-search">
                      <img src="assets/images-fuel/searchIcon.svg" alt="search-icon" />
                      <input type="text" [placeholder]="t('filters.searchAccounts')" />
                    </div>
                  </li>
                  <li>
                    <div>
                      <label class="parent-check-box">
                        <input type="checkbox" id="parent-task" />
                        <span>{{ t('locations.southAfrica') }}</span>
                      </label>
                      <div class="task-group">
                        <label>
                          <input type="checkbox" id="child-task-1" />
                          <span>{{ t('locations.johannesburg') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-2" />
                          <span>{{ t('locations.polokwane') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-3" />
                          <span>{{ t('locations.gqeberha') }}</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <label class="parent-check-box">
                        <input type="checkbox" id="parent-task" />
                        <span>{{ t('locations.zambia') }}</span>
                      </label>
                      <div class="task-group">
                        <label>
                          <input type="checkbox" id="child-task-1" />
                          <span>{{ t('locations.lusaka') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-2" />
                          <span>{{ t('locations.chingola') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-3" />
                          <span>{{ t('locations.kasama') }}</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <label class="parent-check-box">
                        <input type="checkbox" id="parent-task" />
                        <span>{{ t('locations.mozambique') }}</span>
                      </label>
                      <div class="task-group">
                        <label>
                          <input type="checkbox" id="child-task-1" />
                          <span>{{ t('locations.maputo') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-2" />
                          <span>{{ t('locations.pemba') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-3" />
                          <span>{{ t('locations.nampula') }}</span>
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="common-filter driver-filter common-dropdown-checkbox">
              <div class="common-drop-down dropdown dropdown-icon-right">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-menu-button"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  {{ t('filters.filterByDrivers') }}
                  <img src="assets/images-fuel/filterDrpDwnIcon.svg" alt="">
                </button>

                <ul class="dropdown-menu large-menu dropdown-menu-end checkbox-wrapper"
                  aria-labelledby="dropdown-menu-button" (click)="buttonMenuClick($event)">
                  <li>
                    <div class="dropdown-search drop-down-search">
                      <img src="assets/images-fuel/searchIcon.svg" alt="search-icon" />
                      <input type="text" [placeholder]="t('filters.searchAccounts')" />
                    </div>
                  </li>
                  <li>
                    <div>
                      <label class="parent-check-box">
                        <input type="checkbox" id="parent-task" />
                        <span>{{ t('locations.southAfrica') }}</span>
                      </label>
                      <div class="task-group">
                        <label>
                          <input type="checkbox" id="child-task-1" />
                          <span>{{ t('locations.johannesburg') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-2" />
                          <span>{{ t('locations.polokwane') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-3" />
                          <span>{{ t('locations.gqeberha') }}</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <label class="parent-check-box">
                        <input type="checkbox" id="parent-task" />
                        <span>{{ t('locations.zambia') }}</span>
                      </label>
                      <div class="task-group">
                        <label>
                          <input type="checkbox" id="child-task-1" />
                          <span>{{ t('locations.lusaka') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-2" />
                          <span>{{ t('locations.chingola') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-3" />
                          <span>{{ t('locations.kasama') }}</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <label class="parent-check-box">
                        <input type="checkbox" id="parent-task" />
                        <span>{{ t('locations.mozambique') }}</span>
                      </label>
                      <div class="task-group">
                        <label>
                          <input type="checkbox" id="child-task-1" />
                          <span>{{ t('locations.maputo') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-2" />
                          <span>{{ t('locations.pemba') }}</span>
                        </label>
                        <label>
                          <input type="checkbox" id="child-task-3" />
                          <span>{{ t('locations.nampula') }}</span>
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="common-drop-down select-box dropdown">
              <app-date-filter [filter]="utilizationDateFilter" [isButtonIntervalSelector]="false"
                [disableCustomDateSelector]="false" [defaultInterval]="defaultInterval"
                (filterChanged)="onUtilizationDateFilterChange($event)">
              </app-date-filter>
            </div>

            <div class="btn-wrapp">
              <div class="common-drop-down no-filter dropdown">
                <button type="button" id="dropdown-menu-button" data-bs-toggle="dropdown" aria-expanded="false">
                  <img src="assets/images-fuel/threeDotBtnIcon.svg" alt="graph-icon" />
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdown-menu-button">
                  <li><a class="dropdown-item">{{ t('units.litres') }}</a></li>
                  <li>
                    <a class="dropdown-item">{{ t('units.litresPerKilometer') }}</a>
                  </li>
                  <li>
                    <a class="dropdown-item">{{ t('units.litresPer100km') }}</a>
                  </li>
                  <li>
                    <a class="dropdown-item">{{ t('units.randsPerLitre') }}</a>
                  </li>
                </ul>
              </div>
              <button class="close-icon" (click)="closeModal()">
                <img src="assets/images-fuel/crossBigIcon.svg" alt="icon-close" />
              </button>
            </div>
          </div>
        </div>
        <div class="grap-down">
          <div class="line-chart">
            @defer (on timer(200ms)) {
            <app-grouped-bar-chart [data]="totalDecreaseBig" [margin]="{ top: 16, right: 5, bottom: 30, left: 30 }"
              [viewMode]="viewMode" [yTicks]="[70,60,50,40,30,20,10,0]" [barWidth]="20" [chartHeight]="333"
              [exportBtn]="true" />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>